module.exports = __webpack_public_path__ + "static/media/mainBgMobile.10309336.png";